// Caché local (localStorage) para los paneles del Home — stale-while-revalidate:
// cada panel pinta AL INSTANTE lo último conocido y refresca por detrás con el
// fetch real. Mismo criterio que el caché del calendario (classes/api.ts).
// Para datos con vigencia (día/semana) se mete la fecha en la clave y se podan
// las versiones viejas para no acumular basura en localStorage.
const PREFIX = 'lm-swr:';

export function readCache<T>(key: string): T | undefined {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : undefined;
  } catch { return undefined; }
}

export function writeCache(key: string, value: unknown) {
  try { localStorage.setItem(PREFIX + key, JSON.stringify(value)); } catch { /* sin espacio: no pasa nada */ }
}

/** Borra todas las variantes fechadas de un grupo (`grupo:2026-07-01`) salvo la clave actual. */
export function pruneCacheGroup(group: string, currentKey: string) {
  try {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PREFIX + group + ':') && k !== PREFIX + currentKey) localStorage.removeItem(k);
    }
  } catch { /* ignorar */ }
}
